var _JSON$parse;
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { isAuth, dropDownSearchNo, dropDownSearch } from '@/utils';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
// import '@/styles/editor.css'; // global css
Vue.config.productionTip = false;
Vue.prototype.isAuth = isAuth; // 权限方法
Vue.prototype.dropDownSearchNo = dropDownSearchNo; // 下拉检索
Vue.prototype.dropDownSearch = dropDownSearch; // 下拉检索
import 'normalize.css/normalize.css'; //css resets
import '@/styles/index.scss'; // global css

// 国际化格式日期,国家货币
import { i18nFormatDate, i18nCurrencyUnit, countryAndCurrencyInfo, getFormatDate, dateChronaxie } from '@/utils/public';
Vue.prototype.i18nFormatDate = i18nFormatDate;
Vue.prototype.i18nCurrencyUnit = i18nCurrencyUnit;
Vue.prototype.countryAndCurrencyInfo = countryAndCurrencyInfo;
Vue.prototype.getFormatDate = getFormatDate;
Vue.prototype.dateChronaxie = dateChronaxie;
import './icons'; //icon
import './permission'; // 路由导航守卫
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.use(Antd);
import { Input, Tree, Form, FormItem, Timeline, TimelineItem, Steps, Step, DatePicker, Tag, Button, MessageBox, Alert, Select, Option, Table, TableColumn, CascaderPanel, ColorPicker } from 'element-ui';
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';

// 国际化
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
import messages from './lang/index';
// 配置i18n
const i18n = new VueI18n({
  locale: sessionStorage.getItem('locale') || 'en_US',
  // 从缓存中获取当前的语言类型
  messages
});
if (((_JSON$parse = JSON.parse(sessionStorage.getItem('countryAndCurrencyInfo'))) === null || _JSON$parse === void 0 || (_JSON$parse = _JSON$parse.countryInfo) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.name) == '中国大陆') {
  require('@/styles/editor.css'); // global css
}
// import i18n from './lang/index';
// Vue.use(ElementUI);
Vue.use(Input);
Vue.use(Tree);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Steps);
Vue.use(Step);
Vue.use(DatePicker);
Vue.use(Tag);
Vue.use(Button);
Vue.use(Alert);
Vue.use(Select);
Vue.use(Option);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(CascaderPanel);
Vue.use(ColorPicker);
Vue.prototype.$alert = MessageBox.alert;
import scrollBar from '@/components/scrollBar';
import '@/components/scrollBar/index.scss';
Vue.component('scroll-bar', scrollBar);
import menuTitle from '@/layouts/components/sideBar/menuTitle.vue';
Vue.component('menu-title', menuTitle);

// 暂时没用到，可以压缩 JS
// import {mockXHR} from '../mock';
// if (process.env.NODE_ENV === 'production') {
//   mockXHR();
// }

import Vue2OrgTree from 'vue2-org-tree';
Vue.use(Vue2OrgTree);
import loading from '@/components/loading/loading'; // 引入loading
Vue.use(loading); // 全局使用loading

window.vm = new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');